import { Button } from "@workspace/ui/components/button";
import { ArrowRight } from "lucide-react";
import { signIn } from "next-auth/react";
import { GoogleLogo } from "../icons/GoogleLogo";

export const GoogleSignInButton = () => {
  return (
    <Button
      onClick={() =>
        void signIn("google", undefined, {
          prompt: "select_account",
        })
      }
      variant="outline"
      className="flex w-full justify-between py-2 pl-3 pr-2 text-xs"
    >
      <span className="flex items-center gap-2">
        <GoogleLogo className="h-3.5 w-3.5" />
        <span>Continue with Google</span>
      </span>
      <ArrowRight size={14} className="flex-shrink-0 font-bold" />
    </Button>
  );
};
